import { render, staticRenderFns } from "./aboutBanner.vue?vue&type=template&id=957eccd2&scoped=true"
import script from "./aboutBanner.vue?vue&type=script&lang=js"
export * from "./aboutBanner.vue?vue&type=script&lang=js"
import style1 from "./aboutBanner.vue?vue&type=style&index=1&id=957eccd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957eccd2",
  null
  
)

export default component.exports